export const orderModule = {
  order: "Order",
  orderPlural: "Orders",
  sales: "Sales",
  adhoc: "Adhoc",
};

export const fleetModule = {
  fleet: "Fleet",
  fleets: "Fleets",
  driver: "Driver",
  driverPlural: "Drivers",
  vehicle: "Vehicle",
  vehiclePlural: "Vehicles",
};

export const customerModule = {
  customer: "Customer",
  customerPlural: "Customers",
};

export const customerAddressModule = {
  customerAddress: "Customer Address",
  customerAddressPlural: "Customers Addresses",
};

export const customerLocationUpdateModule = {
  customerLocationUpdate: "Customer Location Update Logs",
};

export const itemModule = {
  item: "Item",
  itemPlural: "Items",
};

export const userModule = {
  user: "User",
  userPlural: "Users",
};

export const configurationModule = {
  configuration: "Configuration",
  branch: "Branch",
  project: "Project",
  projectPlural: "Projects",
  branchPlural: "Branches",
  branchManagement: "Branch Management",
  warehouse: "Warehouse",
  warehousePlural: "Warehouses",
  integrationPartnerPlural:"Integration Partners",
  integrationPartner:"Integration Partner",
  fieldConfiguration: "Field Configuration",
  fieldConfigurationPlural: "Field Configurations",
  paymentMethod: "Payment Method",
  paymentMethodPlural: "Payment Methods",
  role: "Role",
  rolePlural: "Roles",
  companyConfiguration: "Company Configuration",
  apiToken: "API Token",
  apiTokenPlural: "API Tokens",
  storageType: "Storage Type",
  storageTypePlural: "Storage Types",
};

export const tripPlanningModule = {
  driverZone: "Driver Zone",
  driverZonePlural: "Driver Zones",
  planningTemplate: "Planning Template",
  planningTemplatePlural: "Planning Templates",
  tripPlan: "Trip Plan",
  regionRestriction: "Region Restriction",
  regionRestrictionPlural: "Region Restrictions",
  tag: "Tag",
  tagPlural: "Tags",
  template: "Template",
  templatePlural: "Templates",
  plan: "Plan",
  planPlural: "Plans",
  recentPlan: "Recent Plan",
  recentPlanPlural: "Recent Plans",
};

export const tripModule = {
  trip: "Trip",
  tripPlural: "Trips",
};

export const integrationLogsModule = {
  integrationLog: "Integration Log",
  integrationLogPlural: "Integration Logs",
  integrationDoc: "Integration Doc",
  integrationDocPlural: "Integration Docs",
};

export const reportsModule = {
  reportPlural: "Reports",
};

export const supportModule = {
  support: "Support",
  ticket: "Ticket",
};

export const clientDashboardModule = {
  dashboard: "Dashboard",
  dashboardPlural: "Dashboards",
  fleetCapacity: "Fleet Capacity",
  topOrderReason: "Top Order Reason",
};

export const adminDashboardModule = {
  dashboard: "Dashboard",
  dashboardPlural: "Dashboards",
  subscription: "Subscription",
  subscriptionPlural: "Subscriptions",
};

export const subscriptionModule = {
  subscription: "Subscription",
  subscriptionPlural: "Subscriptions",
}

export const announcementModule = {
  announcement: "Announcement",
  announcementPlural: "Announcements",
};

export const companyModule = {
  company: "Company",
  companyPlural: "Companies",
};

export const accountAdminModule = {
  accountAdmin: "Account Admin",
  accountAdminPlural: "Account Admins",
};

export const accountManagerModule = {
  accountManager: "Account Manager",
  accountManagerPlural: "Account Managers",
};

export const operationalAnalyticsModule = {
  operationalAnalytic: "Operational Analytic",
  operationalAnalyticPlural: "Operational Analytics",
};

export const statusMapping = {
  status: "Status",
  orderStatus: "Order Status",
  tripStatus: "Trip Status",
  driverStatus: "Driver Status",
  vehicleStatus: "Vehicle Status",
};

export const customFieldModule = {
  customField: "Custom Field",
  customFieldPlural: "Custom Fields",
};